/* © 2024 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import { EmbersTypography } from '../../typography';
import { StyledMarketingImage } from './styles';
export var ImageRow = function ImageRow(_ref) {
  var image = _ref.image,
    wrapSize = _ref.wrapSize,
    title = _ref.title,
    description = _ref.description,
    titleProps = _ref.titleProps;
  return /*#__PURE__*/React.createElement(StyledMarketingImage, {
    wrapSize: wrapSize,
    className: "EmbersTemplate-marketing-content EmbersTemplate-marketingImage-root"
  }, /*#__PURE__*/React.createElement("div", {
    className: "EmbersTemplate-marketingImage-text"
  }, /*#__PURE__*/React.createElement(EmbersTypography, {
    variant: (titleProps === null || titleProps === void 0 ? void 0 : titleProps.variant) || 'headerD',
    componentType: (titleProps === null || titleProps === void 0 ? void 0 : titleProps.componentType) || 'h2'
  }, title), /*#__PURE__*/React.createElement(EmbersTypography, {
    variant: "body",
    margin: 0
  }, description)), image);
};